import { GIT_BOOK_RWA } from '@ui/constants/links';
import { ONE_HOUR_MS, ONE_MINUTE_MS } from '@ui/constants/time';

/**
 * a one minute buffer for nextOpen and nextClose timer for SC and BE to update, reduce occurrence that user failing trade
 */
export const MS_COUNTDOWN_BUFFER = ONE_MINUTE_MS;
export const MS_BEFORE_CLOSE_THRESHOLD = ONE_HOUR_MS;
export const MARKET_CLOSE_GITBOOK_LINK = GIT_BOOK_RWA;
